import React from "react";
import { Link } from "react-router-dom";
import "./footer.css";

import logo from "../EventNavigation/Proptech Club.png";
import { FaPhoneAlt } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import { FaLocationDot } from "react-icons/fa6";
import { FaFacebook } from "react-icons/fa";
import { RiInstagramFill } from "react-icons/ri";
import { FaLinkedin } from "react-icons/fa";


const Footer = () => {
    const handleCall = () => {
        window.open(`tel:+92 323 2675312`, '_blank');
    };

    const handleMail = () => {
        window.open(`mailto:info@proptechclub.org`, '_blank');
    };

    const handleLocate = () => {
        window.open(`https://www.google.com/maps/search/?api=1&query=PropTech+Club+Karachi+Pakistan`, '_blank');
    };

    return (
        <>
            <section id="footer_section">

                <div id="footer_Info_div">
                    <img id="footer_logo" src={logo} alt="PropTech Club logo" />

                    <p id="footer_info_txt">
                        PropTech Club is a community built for real estate professionals, tech innovators, investors, and ecosystem leaders. We bring the industry together through curated events, strategic networking, and forward-looking conversations that accelerate innovation across Pakistan's property landscape.
                    </p>
                </div>

                <div id="footer_contact_div">
                    <h5 id="footer_links_hdng">
                       Contact PropTech Club
                    </h5>
                    <div id="footer_links_div">
                        <div style={{ width: '50%', flexWrap: 'wrap' }}>
                            <p
                                onClick={handleCall}
                                className="footer_links_txt" id="phone"><FaPhoneAlt /> +92 323 2675312</p>
                            <p
                                onClick={handleMail}
                                className="footer_links_txt" id="mail"><IoMdMail /> info@proptechclub.org</p>
                        </div>

                        <p
                            onClick={handleLocate}
                            className="footer_links_txt" id="address" style={{ width: "70%" }}><FaLocationDot /> PropTech Club, Karachi, Pakistan</p>
                    </div>

                    <h5 id="social_hdng">
                        Let's Get Social
                    </h5>
                    <div id="social_icns_div">
                        <Link id="link" target='_blank' to='https://www.facebook.com/theproptechclub'>
                            <FaFacebook
                                style={{ color: 'whitesmoke', fontSize: '20px', cursor: 'pointer' }} />
                        </Link>

                        <Link id="link" target='_blank' to='https://www.instagram.com/proptech.club/'>
                            <RiInstagramFill
                                style={{ color: 'whitesmoke', fontSize: '21px', cursor: 'pointer' }} />
                        </Link>

                        <Link id="link" target='_blank' to='https://www.linkedin.com/company/113116194/admin/dashboard/'>
                            <FaLinkedin
                                style={{ color: 'whitesmoke', fontSize: '20px', cursor: 'pointer' }} />
                        </Link>
                    </div>

                    <div id="footer_legal_div">
                        <Link id="footer_privacy_link" to="/privacy-policy">
                            Privacy Policy
                        </Link>
                    </div>
                </div>

            </section >
        </>
    );
};

export default Footer;
